import React from "react";

const Iconrenderer = ({ url }) => {
  return <img src={url} alt="icon" width="25" height="25" />;
};

export default Iconrenderer;
